/**
 * @generated SignedSource<<18802696bd7939b223c2d866b4c0ce4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignSupplierSpellingInput = {
  id: string;
  spelling: string;
};
export type MergeSupplierDialogMutation$variables = {
  input: AssignSupplierSpellingInput;
};
export type MergeSupplierDialogMutation$data = {
  readonly assignSupplierSpelling: {
    readonly id: string;
    readonly spellings: ReadonlyArray<string>;
  };
};
export type MergeSupplierDialogMutation = {
  response: MergeSupplierDialogMutation$data;
  variables: MergeSupplierDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "assignSupplierSpelling",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spellings",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeSupplierDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MergeSupplierDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2cdd389a9a76b04ff08737a9dffb5bb9",
    "id": null,
    "metadata": {},
    "name": "MergeSupplierDialogMutation",
    "operationKind": "mutation",
    "text": "mutation MergeSupplierDialogMutation(\n  $input: AssignSupplierSpellingInput!\n) {\n  assignSupplierSpelling(input: $input) {\n    id\n    spellings\n  }\n}\n"
  }
};
})();

(node as any).hash = "818fdcb275284c9953883b755d293dbb";

export default node;
